import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const navBarItems = [
    { name: "خانه", id: 1, onClick: () => navigate("/") },

    { name: "تماس با ما", id: 2, onClick: () => navigate("/contact-us") },
  ];
  const [navbarOpen, setNavbarOpen] = useState(false);
  return (
    <header className=" bg-bgBlue max-md:bg-white relative">
      <div className="container mx-auto flex justify-between  p-2 max-w-5xl ">
        <div className=" font-bold flex flex-row gap-1 text-nowrap items-center justify-around">
          <img
            src="/assets/images/logo.png"
            alt="My Icon"
            className=" max-md:hidden"
          />
          <img
            src="/assets/images/logo-black.png"
            alt="My Icon"
            className="hidden max-md:block cursor-pointer"
            onClick={() => navigate("/")}
          />
          <span
            className=" text-xl text-white max-md:text-black cursor-pointer"
            onClick={() => navigate("/")}
          >
            کلینیک لانجویتی دکتر شکیبی
          </span>
        </div>
        <nav className="flex items-center justify-center burger-menu-container z-10">
          <div
            className={`!hidden max-md:!flex  burger-icon  ${
              navbarOpen ? "open" : ""
            }`}
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>

          <ul className=" flex text-gray-300 items-center font-bold  z-30 max-md:hidden">
            <li className="">
              <a
                href=""
                className=" hover:text-white   hover-border  px-4 py-4 relative block"
                onClick={() => navigate("/")}
              >
                خانه
              </a>
            </li>

            <li>
              <a
                href=""
                className=" hover:text-white   hover-border  px-4 py-4 relative block"
                onClick={() => navigate("/contact-us")}
              >
                تماس با ما
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <ul
        className={`hidden max-md:block
        list-container max-md:bg-white w-full z-30 ${
          navbarOpen ? "list-show   border-t-2" : "list-hide"
        } `}
      >
        {navBarItems.map((item) => (
          <li id={item.id} className=" list-item ">
            <a
              href=""
              className=" hover:text-border-color  text-white-half   px-4 py-6  block"
              onClick={item.onClick}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </header>
  );
};

export default Header;
/* "transition-all duration-300 border-t-4   text-black font-bold   overflow-y-hidden max-md:min-w-full max-md:grid max-md:grid-rows-[1fr]" */
